angular
    .module('festzelt-os.modules.bo.option-links')
    .factory('deleteOptionLinks', [
        'Alert',
        '$http',
        'SweetAlert',
        (Alert, $http, SweetAlert) => new DeleteOptionLinksWorkflow(Alert, $http, SweetAlert)
    ]);

// @todo new alert - do we use it?
class DeleteOptionLinksWorkflow {
    constructor(Alert, $http, SweetAlert) {
        this.alert = Alert;
        this.api = $http;
        this.sweetAlert = SweetAlert;

        this.key = `delete-option-links`;
        this.title = `Archive selected`;
        this.level = 'selected';
    }

    action({}, store) {
        this.alert.confirm({
            title: 'Delete option links',
            message: 'Are you sure, that you want to delete the selected option-links?',
            type: 'warning',
            confirmBtn: 'Yes, delete selected',
            wait: true
        }).then(() => {
            this.api.delete(store.state.slug, {
                data: {
                    'option-links': store.getters.selectedFilters
                }
            }).then(() => {
                this.sweetAlert.close();
                this.alert.success('Success', 'Delete option links started');

                store.dispatch('getData');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/workflows/option-links-list/delete-option-links.js